import { STORE_NAV_ITEMS } from 'layout/storeNavItems';
import { CAPABILITIES } from 'utils/capabilities';

export const ROUTES = {
    ADMIN_SETTING: '/user/settings',
    WELCOME: '/user/welcome',
}

/**
 * Where a user lands after login, or when sent "home".
 *
 * Roles with the dashboard land on it. A narrow role lands on the first page
 * of the store menu it can actually use (an accountant arrives at Accounting,
 * not at a dashboard it cannot read). Hosts and PureBrand admins hold no
 * capabilities and keep the welcome page, which renders their own home.
 *
 * @param {Iterable<String>|Function} capabilities a Set/array of codes, or a `can(code)` function
 * @returns {String} path
 */
export const landingPathFor = (capabilities) => {
    const can = typeof capabilities === 'function'
        ? capabilities
        : (code) => new Set(capabilities || []).has(code);

    const hasAny = STORE_NAV_ITEMS.some((item) => item.capability && can(item.capability));
    if (!hasAny || can(CAPABILITIES.DASHBOARD_VIEW)) {
        return ROUTES.WELCOME;
    }

    const first = STORE_NAV_ITEMS.find((item) => item.capability && can(item.capability));
    return first ? first.path : ROUTES.WELCOME;
}
